import React from "react";

export const UnitNameInput = ({name, onChange, errors}) => {

  const handleNameChange = (event) => {
    onChange(event.target.value);
  }

  const hasError = errors && errors.length !== 0;

  return (
      <div className="flex-1">
        <label className="block text-xs font-medium text-gray-700 mb-1">
          Name/Firma
        </label>
        <input
            type="text"
            placeholder="Name/Firma eingeben"
            value={name}
            onChange={handleNameChange}
            className={`w-full text-sm px-3 py-2 border rounded focus:outline-none focus:ring-1 ${
                hasError
                    ? "border-red-500 focus:ring-red-500 focus:border-red-500"
                    : "border-gray-300 focus:ring-orange-500 focus:border-orange-500"
            }`}
        />
        {hasError && (
            <p className="mt-1 text-xs text-red-500">{errors[0].defaultMessage}</p>
        )}
      </div>);
};